/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CrudSystemActionSubject } from './CrudSystemActionSubject';
import {
    instanceOfCrudSystemActionSubject,
    CrudSystemActionSubjectFromJSON,
    CrudSystemActionSubjectFromJSONTyped,
    CrudSystemActionSubjectToJSON,
} from './CrudSystemActionSubject';
import type { ExecutionSystemActionSubject } from './ExecutionSystemActionSubject';
import {
    instanceOfExecutionSystemActionSubject,
    ExecutionSystemActionSubjectFromJSON,
    ExecutionSystemActionSubjectFromJSONTyped,
    ExecutionSystemActionSubjectToJSON,
} from './ExecutionSystemActionSubject';
import type { PresetSystemActionSubject } from './PresetSystemActionSubject';
import {
    instanceOfPresetSystemActionSubject,
    PresetSystemActionSubjectFromJSON,
    PresetSystemActionSubjectFromJSONTyped,
    PresetSystemActionSubjectToJSON,
} from './PresetSystemActionSubject';

/**
 * @type SystemActionPoliciesEntitySubject
 * APIタグ
 * @export
 */
export type SystemActionPoliciesEntitySubject = CrudSystemActionSubject | ExecutionSystemActionSubject | PresetSystemActionSubject;

export function SystemActionPoliciesEntitySubjectFromJSON(json: any): SystemActionPoliciesEntitySubject {
    return SystemActionPoliciesEntitySubjectFromJSONTyped(json, false);
}

export function SystemActionPoliciesEntitySubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemActionPoliciesEntitySubject {
    if (json == null) {
        return json;
    }
    if (instanceOfCrudSystemActionSubject(json)) {
        return CrudSystemActionSubjectFromJSONTyped(json, true);
    }
    if (instanceOfExecutionSystemActionSubject(json)) {
        return ExecutionSystemActionSubjectFromJSONTyped(json, true);
    }
    if (instanceOfPresetSystemActionSubject(json)) {
        return PresetSystemActionSubjectFromJSONTyped(json, true);
    }

    return {} as any;
}

export function SystemActionPoliciesEntitySubjectToJSON(json: any): any {
    return SystemActionPoliciesEntitySubjectToJSONTyped(json, false);
}

export function SystemActionPoliciesEntitySubjectToJSONTyped(value?: SystemActionPoliciesEntitySubject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfCrudSystemActionSubject(value)) {
        return CrudSystemActionSubjectToJSON(value as CrudSystemActionSubject);
    }
    if (instanceOfExecutionSystemActionSubject(value)) {
        return ExecutionSystemActionSubjectToJSON(value as ExecutionSystemActionSubject);
    }
    if (instanceOfPresetSystemActionSubject(value)) {
        return PresetSystemActionSubjectToJSON(value as PresetSystemActionSubject);
    }

    return {};
}

